import React, { useMemo, useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
// import { getSettingsData, settingsSelector } from '../../../store/slices/settings';
import {
  Box,
  Button,

  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Link,
  Tooltip
} from "@mui/material";

import _ from "lodash";
import CommonTopics from './commonTopics'
// import { convertArrayToDictionary, getNumeric } from '../../../common/utils'
import * as d3 from 'd3';
// import JsonObjectModal from "../modals/jsonObjectModal";
import { TopicChip as Chip } from "./topicChip";
import { convertArrayToDictionary, getNumeric } from "../../../common/utils";

const ratingScale = d3.scaleSequential(d3.interpolateRdYlGn).domain([1.0, 5.0]);

const CompanyTopics = ({companyId, companyTopics, businessTypeId }) => {
  const topicsData = useMemo(() => companyTopics, [companyTopics])
//   const { companyId, userRoles } = useSelector(reviewDataSelector)
  const [isOpenTopicMoal, toogleTopicModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isOpenJsonModel, toogleJsonModal] = useState(false);
  const [isOpenHistoryModel, toogleHistoryModal] = useState(false);
  const [appendedJsonObject, setAppendedJsonObject] = useState('');
  const [jsonObj, setJsonObject] = useState('');
  const dispatch = useDispatch();

console.log('companyTopics', companyTopics);


  // useEffect(() => { if (companyId) { dispatch(getSettingsData(companyId)) } }, [companyId])

  const getTabData = () => {
    if (topicsData) {
      let groupedByParentTopicId = _.groupBy(topicsData, "parentTopicId");
      let data = [];
      if (groupedByParentTopicId) {
        let childTopicId = _.omit(groupedByParentTopicId, "null");
        let parentIDs = groupedByParentTopicId["null"]?.map((x) => x.topicId);
        let parentObj = groupedByParentTopicId["null"];
        parentIDs?.map((key) => {
          let parentElement = parentObj.find((x) => x.topicId === key);
          return data.push({
            parentId: parentElement.topicId,
            parentName: parentElement.name,
            sequence: parentElement.sequence,
            childTopics: _.sortBy(childTopicId[key], "sequence"),
          });
        });
        return _.sortBy(data, "sequence");
      }
    }
  };

  const topicsTabdata = useMemo(() => getTabData(), [topicsData]);
  const bindSubTopics = (subTopics) => {
    return _.map(subTopics, it => {
      it.positivePct = (it.positiveCount / it.count) * 100
      it.negativePct = ((it.count - it.positiveCount) / it.count) * 100
      return it;
    })
  }
  const subTopicDic = useMemo(() => convertArrayToDictionary(bindSubTopics(_.filter(_.cloneDeep(topicsData), it=> { return it.parentTopicId})) ?? [], 'name'), [topicsData]);

  const onToogleTopicsModal = (isOpen) => {
    toogleTopicModal(isOpen);
  }
  const onToogleHistoryModal = (isOpen) => {
    toogleHistoryModal(isOpen);
  }
  const onGenerate = () => {
    setAppendedJsonObject(jsonObj);
    onToogleJsonModal(false);

  }
  const onToogleJsonModal = (isOpen) => {
    toogleJsonModal(isOpen);
    setJsonObject('');
  }
  const onSetEdit = (isOpen) => {
    setIsEdit(isOpen);
  }
  const handleClick = () => {
    console.info('You clicked the Chip.');
  };

  const handleDelete = () => {
    console.info('You clicked the delete icon.');
  };
  const jsonObjectComponent = () => {
    return <Link
      component="button"
      variant='contained'
      color='primary'
      sx={{ width: "100px" }} onClick={(e) => { onToogleJsonModal(true); }}>Input Json</Link>

  }
  return (
    <>
      <Box contentSX={{ height: "calc(100vh - 150px)" }}
      //   title={
      //   <Stack
      //     direction="row"
      //     sx={{}}
      //     spacing={1}
      //     justifyContent={"space-between"}
      //     alignItems={"center"}

      //   >
      //     <InputLabel sx={{}}>
      //       <Typography variant="subtitle1">Topics:</Typography>
      //     </InputLabel>
      //     <Button
      //       // disabled={checked.length === 0}
      //       color="primary"
      //       variant="contained"
      //       // sx={{ height: '30px'}}
      //       onClick={() => onToogleTopicsModal(true)}
      //     >
      //       Generate Topics
      //     </Button>
      //   </Stack>
      // }
      >

        <CommonTopics  isEdit={isEdit} onSetEdit={onSetEdit} isGenerateTopics={true} height='calc(100vh - 287px)'
          companyId={companyId} onToogleTopicsModal={onToogleTopicsModal} jsonObjectComponent={isEdit? jsonObjectComponent() : null}
          jsonObj={appendedJsonObject && isEdit ? appendedJsonObject : null} showData={isEdit}
          onToogleHistoryModal={!isEdit ? onToogleHistoryModal : null}
          topics={topicsData}
        ></CommonTopics>
       
    

        {topicsTabdata && !isEdit &&
          <div style={{ height: "calc(100vh - 249px)", overflowY: "auto",minHeight:'250px' }}>
            {topicsTabdata.map((item, index) => {
              return (
                <Box
                  key={index + "_parent"}
                  sx={{
                  
                    mt: (theme) =>
                      index > 0 ? theme.spacing(2.5) : theme.spacing(0.5),

                  }}
                >
                  {" "}
                  <InputLabel sx={{ marginBottom: 1 }}>
                    <Typography variant="subtitle1">{item.parentName}</Typography>
                  </InputLabel>
                  <Stack gap={1} direction={'row'} sx={{ pl: 2 }} flexWrap={'wrap'}>
                    {item.childTopics.map((a, i) => {
                     const tooltipCal='Negative: ' + getNumeric(100 - subTopicDic[a.name]?.positivePct, true) + '%, Positive: ' + getNumeric(subTopicDic[a.name]?.positivePct, true) + '%';
                     const description=a?.description??'';
                     const positiveContext=a?.positiveContext??""
                     const negativeContext=a?.negativeContext??""
                     const toolTipText=<div style={{whiteSpace:'pre-wrap',width:'100%'}}>{tooltipCal}<br/>{positiveContext&&("Positive Context: "+positiveContext)}{negativeContext&&("\nNegative Context: "+negativeContext)}</div>
                     return(<Tooltip title={toolTipText} disableInteractive arrow>
                            <span>
                          <Chip

                            key={i + "_child"}
                            label={a.name + (subTopicDic[a.name]?.count ? (' (' + getNumeric(subTopicDic[a.name]?.count, false) + ')') : '')}
                            variant="outlined"
                            // onClick={handleClick}
                            sx={{
                              borderRadius:'16px',
                              // color: subTopicDic[a.name]?.positivePct || subTopicDic[a.name]?.negativePct ? '#fff' : '#000',
                           
                             
                            
                              background: (theme) => `linear-gradient(270deg,${'#ECFDF3'} 0 ${subTopicDic[a.name]?.positivePct}%,${'#FEF3F2'} 0 ${100 - subTopicDic[a.name]?.positivePct}%)`
                            }}
                          />
                          </span>
                      </Tooltip>)

            })}
                  </Stack>
                </Box>
              );
            })}
        </div>
         
        }

      </Box>
      {/* {isOpenTopicMoal &&
        <GenerateTopicsModal open={isOpenTopicMoal} companyId={companyData?.companyId} setOpen={onToogleTopicsModal} />
      }
      {isOpenHistoryModel &&
        <GenerateTopicHistoryModal open={isOpenHistoryModel} companyId={companyData?.companyId} setOpen={onToogleHistoryModal} />
      }
      {isOpenJsonModel &&
        <JsonObjectModal open={isOpenJsonModel} onGenerate={onGenerate} jsonObj={jsonObj} setOpen={onToogleJsonModal} setJsonObject={setJsonObject} />
      } */}
   </>
    
  );
};

export default CompanyTopics;